<template>
  <button
    :class="[
      'product-detail',
      'product-detail-vue',
      bemBlockMod({
        disabled: !selectedMainProduct || disabled,
      }),
    ]"
    :data-context="context"
    @click="handleProductClick"
  >
    <BaseProductDataForSfra :product="product" />
    <img
      :class="bemElement('image')"
      :src="imageUrl"
      :alt="product.productName"
    />
    <div
      v-if="selectedCurrentProduct && selectedCurrentProduct.qty > 0"
      :class="bemElement('image-underline')"
    />
    <div
      v-if="selectedCurrentProduct && selectedCurrentProduct.qty > 1"
      :class="bemElement('amount-indicator')"
    >
      <span :class="bemElement('amount-number')">
        {{ selectedCurrentProduct.qty }}
      </span>
    </div>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';
import { getters, types } from '../../store';
import EventBusConfig from '../../config/eventBusConfig';
import getFrontConfig from '../../../common/getFrontConfig';
import bemClassesMixin from '../../mixins/bemClassesMixin';
import productPropSizesMixin from '../../mixins/productPropSizesMixin';
import sfraProductMixin from '../../mixins/sfraProductMixin';
import BaseProductDataForSfra from '../BaseProductDataForSfra.vue';
import { isSameVariationGroup } from '../../../common/helpers/productModelHelpers';
import { isVariationProductId } from '../../../common/helpers/productIdHelpers';

const {
  urls: { customizerResources },
} = getFrontConfig();
const FRONT_CONFIG = getFrontConfig();

export default {
  name: 'TheProductCustomizerComplement',

  components: {
    BaseProductDataForSfra,
  },

  mixins: [bemClassesMixin, productPropSizesMixin, sfraProductMixin],

  props: {
    reset: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      disabled: true,
      context: FRONT_CONFIG.vue.TheProductCustomizer.context.productCustomizer, // customizer
    };
  },

  computed: {
    ...mapGetters({
      selectedMainProduct: getters.productCustomizer.selectedMainProduct,
      selectedComplementProducts:
        getters.productCustomizer.selectedComplementProducts,
    }),
    selectedCurrentProduct() {
      return this.selectedComplementProducts?.find((complement) =>
        isSameVariationGroup(complement.pid, this.product.id)
      );
    },
    imageUrl() {
      return `${
        customizerResources + this.product.id.replaceAll('.', '_')
      }.png`;
    },
    size() {
      return this.getUniqueSize();
    },
  },

  watch: {
    reset() {
      if (this.reset) {
        this.handleResetComplement();
      }
    },
  },

  mounted() {
    this.initComplementState();
    this.$eventBus.$on(
      EventBusConfig.commands.TheProductDetails.updateProduct,
      this.handleSelectVariation
    );
    this.$eventBus.$on(
      EventBusConfig.commands.TheProductCustomizer.removeComplement,
      this.handleRemoveComplement
    );
  },

  beforeDestroy() {
    this.$eventBus.$off(
      EventBusConfig.commands.TheProductDetails.updateProduct,
      this.handleSelectVariation
    );
    this.$eventBus.$off(
      EventBusConfig.commands.TheProductCustomizer.removeComplement,
      this.handleRemoveComplement
    );
  },

  methods: {
    initComplementState() {
      if (this.hasUniqueSize()) {
        this.disabled = !this.getUniqueSize().selectable;
      }
    },
    handleProductClick() {
      if (this.hasUniqueSize()) {
        this.sfraSelectSize(this.size);
        this.disabled = !this.sfraSelectQuantity(
          (this.selectedCurrentProduct?.qty || 0) + 1
        );
      }
    },
    handleRemoveComplement(complement) {
      const isCurrent = isSameVariationGroup(complement, this.product.id);
      if (isCurrent) {
        if (this.selectedCurrentProduct?.qty > 1) {
          this.disabled = !this.sfraSelectQuantity(
            this.selectedCurrentProduct?.qty - 1
          );
        } else {
          this.handleResetComplement();
        }
      }
    },
    handleResetComplement() {
      this.initComplementState();
      this.sfraSelectSize({ url: this.sizeResetUrl });
    },
    handleSelectVariation({ product, container }) {
      if (container.dataset.context !== this.context) {
        return;
      }

      const isCurrent = isSameVariationGroup(product.id, this.product.id);
      if (isCurrent) {
        const remove = !isVariationProductId(product.id);
        if (remove) {
          this.$store.dispatch(
            types.productCustomizer.removeComplementProduct,
            product.id
          );
        } else {
          if (product.available) {
            const complementProduct = {
              pid: product.id,
              qty: product.selectedQuantity,
              price: product.price.sales
                ? product.price.sales.value
                : product.price.list.value,
              storeId: null,
            };
            this.$store.dispatch(
              types.productCustomizer.updateComplementProduct,
              complementProduct
            );
          }
          this.disabled = !product.available;
        }
      }
    },
  },
};
</script>
